<script lang="ts" setup>
const { logoDark, logoLight } = useBrand()
</script>

<template>
  <div
    data-testid="trading-workspace-loader"
    class="bg-main z-2000 flex h-full w-full flex-col items-center justify-center gap-6"
  >
    <div class="hidden justify-self-start dark:block">
      <img :src="logoDark" alt="Logo" class="h-6 w-33 shrink-0 object-contain" />
    </div>
    <div class="justify-self-start dark:hidden">
      <img :src="logoLight" alt="Logo" class="h-6 w-33 shrink-0 object-contain" />
    </div>
    <UProgress class="max-w-48" />
    <div class="text-center text-sm leading-5">
      <p>Preparing your trading workspace</p>
      <p>Syncing market data and loading your tools</p>
    </div>
  </div>
</template>
